import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Toast } from "primereact/toast";
import "../Style.scss";
import { login } from "./LoginAction";
import LoginImage from "../../assets/login.png";

const Login = ({ handleForgotPasswordClick }) => {
  const [checked, setChecked] = useState(false);
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [loginIdRequiredMessage, setLoginIdRequiredMessage] = useState(false);
  const [passwordRequiredMessage, setPasswordRequiredMessage] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const toastRef = useRef(null);

  useEffect(() => {
    const storedLoginId = localStorage.getItem("rememberedLoginId");
    const storedPassword = localStorage.getItem("rememberedPassword");
    if (storedLoginId && storedPassword) {
      setLoginId(storedLoginId);
      setPassword(storedPassword);
      setChecked(true);
    }
  }, []);

  const handleLogin = () => {
    setTimeout(() => {
      login(loginId, password, navigate, toastRef);
      if (checked) {
        localStorage.setItem("rememberedLoginId", loginId);
        localStorage.setItem("rememberedPassword", password);
      } else {
        localStorage.removeItem("rememberedLoginId");
        localStorage.removeItem("rememberedPassword");
      }
    }, 0);
  };

  return (
    <div className="login-container">
      <div className="login-heading"><p>NHM LMS</p></div>
      <div className="login-wrapper">
        <div className="login-image">
          <img
            src={LoginImage}
            alt="Login Visual"
            className="image-content"
          />
        </div>
        <div className="login-form">
          <Toast ref={toastRef} />
          <div className="text-blue-1000">Welcome !</div>
          <div className="text-500">
            Enter Your Credentials To Access Your Account
          </div>
          <div className="label-container">
           
            <p className="text-blue-900"> <span className="text-red-500">*</span> Login ID</p>
          </div>
          <InputText
            className="custom-input"
            value={loginId}
            onChange={(e) => {
              setLoginId(e.target.value);
              setLoginIdRequiredMessage(e.target.value === "");
            }}
            onBlur={(e) => setLoginIdRequiredMessage(e.target.value === "")}
          />
          {loginIdRequiredMessage && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Login ID is required.
            </div>
          )}
          <div className="label-container">
            
            <p className="text-blue-900"> <span className="text-red-500">*</span> Password</p>
          </div>
          <div className="p-inputgroup password-inputgroup">
            <InputText
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordRequiredMessage(e.target.value === "");
              }}
              onBlur={(e) => setPasswordRequiredMessage(e.target.value === "")}
              style={{ height: "2.6rem" }}
            />
            <button
              type="button"
              className="p-inputgroup-addon password-icon-btn"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <FaEye style={{ color: "black" }} />
              ) : (
                <FaEyeSlash style={{ color: "black" }} />
              )}
            </button>
          </div>
          {passwordRequiredMessage && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Password is required.
            </div>
          )}
          <div className="flex flex-row flex-wrap items-center gap-1 mt-4">
            <Checkbox
              className="custom-checkbox"
              onChange={() => setChecked(!checked)}
              checked={checked}
              data-testid="remember-checkbox"
            />
            <div className="remember-me-label">Remember Me</div>
          </div>
          <Button
            className="login-btn"
            onClick={() => {
              setLoginIdRequiredMessage(loginId === "");
              setPasswordRequiredMessage(password === "");
              if (loginId !== "" && password !== "") {
                handleLogin();
              }
            }}
            disabled={loginId === "" || password === ""}
            data-testid="submit-button"
          >
            Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Login;
